import { render, staticRenderFns } from "./LiefengContentManage.vue?vue&type=template&id=a5120736&scoped=true&"
import script from "./LiefengContentManage.vue?vue&type=script&lang=js&"
export * from "./LiefengContentManage.vue?vue&type=script&lang=js&"
import style0 from "./LiefengContentManage.vue?vue&type=style&index=0&id=a5120736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5120736",
  null
  
)

export default component.exports